import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 1.333a.667.667 0 0 0-.667.667v2H6a.667.667 0 0 0-.667.667v2H2a.667.667 0 0 0-.667.666v4A.667.667 0 0 0 2 12h11.333v2a.667.667 0 1 0 1.334 0V2A.666.666 0 0 0 14 1.333m-.667 9.334H2.667V8h10.666zm0-4H6.667V5.333h6.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })